import { AuthSessionProvider } from '@ekhodealer/ekho-common/auth-client';

import { MintlifyLogin } from '@features/mintlify-login/components/MintlifyLogin';
import { auth } from '@config/firebase';
import { apiClient } from '@config/server/apiClient';
import { authEndpoints } from '@config/server/apiEndpoints';
import { queryClient } from '@config/server/queryClient';
import { queries } from '@config/server/queryKeys';

/**
 * Mintlify login page - thin wrapper that provides AuthSessionProvider context
 * and centers the login form content
 */
export default function MintlifyLoginPage() {
	return (
		<AuthSessionProvider
			auth={auth}
			apiClient={apiClient}
			queryClient={queryClient}
			queryKeys={{
				me: queries.auth.me.queryKey,
				debug: queries.auth.debug.queryKey,
			}}
			meEndpoint={authEndpoints.me()}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '100vh',
					padding: '2rem',
				}}>
				<div style={{ maxWidth: '400px', width: '100%' }}>
					<MintlifyLogin />
				</div>
			</div>
		</AuthSessionProvider>
	);
}
